import { setAddressFromAmbiguity } from '../address/address.actions'
import { selectIsItineraryUniverse } from '../history/history.selectors'
import { setStepFromAddress } from '../itinerary/itinerary.actions'

export const setAmbiguityAddress = address => (dispatch, getState) => {
  const isItineraryRoute = selectIsItineraryUniverse(getState())

  return isItineraryRoute
    ? setStepFromAddress(address)(dispatch, getState)
    : setAddressFromAmbiguity(address)(dispatch, getState)
}
